export default "# Hello World\n\nThis is a test\n"